import React from 'react';
import { Select, IOption } from 'components/select/Select';
import {SelectionDropDownAdvanced} from 'damco-components';
interface IFiltersBooleanSelect {
    label: string;
    value?: any; // injected
    id?: any; // injected
    name: string;
    type?: string;
    options: IOption[];
    className?: string;
    isArray?: boolean;
    isInvalid?: boolean;
    isRequired?: boolean;
    setValidity?: (val: boolean) => void;
    relatedField?: string;
    minValue?: string;
    onChange?(value: React.ChangeEvent<HTMLSelectElement>): void;
}

export const FiltersSelect = (props: IFiltersBooleanSelect) => {
    if(props.isArray){
        const formatValue = (orginalData:any[], selectedData:any[]) => {
            let val = [...orginalData]
            val = val.filter((el:any)=>{
                if(el && el.value){
                    return selectedData.includes(el.value)
                }
                return false
            })
            return val
        }
        let defaultValue = props.value && props.value.length > 0? formatValue(props.options, props.value) : [...props.options]
        const onChange = (val:any) =>{
            if(props.onChange){
                props.onChange(val)
            }
            defaultValue = formatValue(props.options, val)
        }
        return(<div className={props.className? props.className: 'col-25'}>
            <SelectionDropDownAdvanced 
                options={props.options} 
                className={props.isInvalid ? 'error':''}
                isDisabled={false} 
                id={props.id}
                isSearchable={true} 
                isMulti={true} 
                onChange={onChange}
                label={props.label}
                isClearable={false}
                defaultValue={defaultValue}
            /></div>)
    }else{
        const options = !props.isRequired?[{ optionText: 'Select value...', value: '' }].concat(props.options):props.options;
        return(
        <div className={props.className? props.className: 'col-25'}>
            <Select
                id={props.id}
                className={props.isInvalid ? 'error':''}
                label={props.label}
                value={props.value}
                onChange={props.onChange}
                options={options}
            />
        </div>
    )
    }
};
